import { render, staticRenderFns } from "./verification-type-select.vue?vue&type=template&id=89a3c952&"
import script from "./verification-type-select.vue?vue&type=script&lang=js&"
export * from "./verification-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports